import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { DeviceMobile, X } from "@phosphor-icons/react";

/*  Listens for the browser's `beforeinstallprompt` event (fired by Chrome on
    Android + desktop Chromium) and shows a small install CTA. Once the user
    taps "Install", the browser handles the rest and the app lands on the
    home screen. Auto-dismisses on iOS (they don't fire the event) and after
    the user has already installed. */
export default function PwaInstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [dismissed, setDismissed] = useState(() => localStorage.getItem("pwa_dismissed") === "1");

  useEffect(() => {
    const h = (e) => { e.preventDefault(); setDeferred(e); };
    window.addEventListener("beforeinstallprompt", h);
    const done = () => setDeferred(null);
    window.addEventListener("appinstalled", done);
    return () => { window.removeEventListener("beforeinstallprompt", h); window.removeEventListener("appinstalled", done); };
  }, []);

  if (!deferred || dismissed) return null;

  // We're a mobile-only install prompt — never surface on desktop
  const isMobile = /Android|iPhone|iPad|iPod|Mobile/.test(navigator.userAgent);
  if (!isMobile) return null;

  const install = async () => {
    try {
      deferred.prompt();
      const { outcome } = await deferred.userChoice;
      if (outcome === "accepted") setDeferred(null);
    } catch { /* ignored */ }
  };
  const later = () => { setDismissed(true); localStorage.setItem("pwa_dismissed", "1"); };

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-xs bg-card border border-primary shadow-lg rounded-md p-3 flex items-start gap-3" data-testid="pwa-install-prompt">
      <div className="mt-0.5 p-2 rounded-sm bg-primary/10 text-primary"><DeviceMobile size={18} /></div>
      <div className="flex-1">
        <div className="text-sm font-semibold">Install SNS RADIUS</div>
        <div className="text-[11px] text-muted-foreground mt-0.5">Add to your home screen for full-screen, offline-ready access.</div>
        <div className="mt-2 flex items-center gap-2">
          <Button size="sm" className="h-7 text-xs rounded-sm" onClick={install} data-testid="pwa-install-btn">Install</Button>
          <button className="text-xs text-muted-foreground hover:text-foreground" onClick={later}>Later</button>
        </div>
      </div>
      <button className="text-muted-foreground hover:text-foreground" onClick={later} aria-label="dismiss"><X size={14} /></button>
    </div>
  );
}
